import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agregarlibro',
  templateUrl: './agregarlibro.component.html',
  styleUrls: ['./agregarlibro.component.scss'],
})
export class AgregarlibroComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
